function switchRelatedProduct(el) {
    const card = el.closest('hdt-card-product');
    if (!card) return;

    const relatedId = el.dataset.relatedId;
    const dataScript = card.querySelector('.related-products-data');
    if (!dataScript) return;

    const data = JSON.parse(dataScript.textContent);
    const productData = data[relatedId];
    if (!productData) return;

    /* 🔹 Swatch activo */
    card.querySelectorAll('.mox-swatch-button').forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    el.classList.add('is-active');
    el.setAttribute('aria-pressed', 'true');

    /* 🔹 Actualizar variant ID en el form */
    const productForm = card.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput && productData.variants && productData.variants.length) {
        const firstAvailableVariant = productData.variants.find(v => v.available);
        if (firstAvailableVariant) {
          variantInput.value = firstAvailableVariant.id;
        }
      }
    }

    /* Imagen */
    const img = card.querySelector('.hdt-card-product__media img');
    if (img && productData.image) {
      img.src = productData.image;
      img.srcset = productData.image;
    }

    /* URL */
    card.querySelectorAll('a[data-pr-url]').forEach(link => {
      link.href = productData.url;
    });

    /* Título */
    const title = card.querySelector('.hdt-card-product__title');
    if (title && productData.title) {
      title.textContent = productData.title;
    }

    /* Badges */
    const badgesWrap = card.querySelector('.hdt-card-product__widget .hdt-badge__wrapp');
    if (typeof productData.badges_html === 'string' && productData.badges_html.trim()) {
      if (badgesWrap) {
        badgesWrap.outerHTML = productData.badges_html;
      } else {
        const widget = card.querySelector('.hdt-card-product__widget');
        if (widget) widget.insertAdjacentHTML('afterbegin', productData.badges_html);
      }
    }

    /* Precio */
    const info = card.querySelector('.hdt-card-product__info');
    const priceWrapper = info ? info.querySelector('.hdt-price-wrapp') : card.querySelector('.hdt-price-wrapp');
    if (priceWrapper && productData.price) {
      const priceRaw = Number(productData.price_raw || 0);
      const compareRaw = Number(productData.compare_at_price_raw || 0);
      const showCompareAt = compareRaw > priceRaw;

      priceWrapper.innerHTML = `
        <div class="hdt-price__list">
          ${showCompareAt
            ? `<hdt-compare-at-price class="hdt-compare-at-price">
                <span class="sr-only sr-only--inline">Regular price</span>
                <span class="hdt-money">${productData.compare_at_price}</span>
              </hdt-compare-at-price>`
            : ''
          }
          <hdt-price class="hdt-price">
            <span class="sr-only sr-only--inline">Sale price</span>
            <span class="hdt-money">${productData.price}</span>
          </hdt-price>
        </div>
      `;
    }

    /* Tallas */
    const overlay = card.querySelector('.hover-size-overlay');
    if (!overlay) return;
    const sizesContainer = overlay.querySelector('.mox-tallas') || overlay;

    sizesContainer.querySelectorAll('.hover-size-item').forEach(b => b.remove());

    productData.variants.forEach(variant => {
      if (!variant.available) return;

      const btn = document.createElement('button');
      btn.className = 'hover-size-item';
      btn.type = 'button';
      btn.dataset.variantId = variant.id;
      btn.textContent = variant.title;

      btn.addEventListener('click', () => {
        overlay.querySelectorAll('.hover-size-item').forEach(b => {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        /* 🔹 Actualizar variant ID en el form */
        const productForm = card.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variant.id;

            /* Notificar cambio por si el theme escucha eventos */
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      sizesContainer.appendChild(btn);
    });
  }

  document.addEventListener('click', function (e) {
    const swatchBtn = e.target.closest('.mox-swatch-button');
    if (swatchBtn) {
      switchRelatedProduct(swatchBtn);
      return;
    }
  });
